export default {
    'TEXT_BOX': 'text',
    'CHECK_BOX': 'checkbox',
    'COMBO_BOX': 'select',
    'TEXT_AREA': 'textarea',
    'DATE_PICKER': 'date',
};
